import { render } from "./collection-sticky-header.vue?vue&type=template&id=20e3c706"
import script from "./collection-sticky-header.vue?vue&type=script&lang=js"
export * from "./collection-sticky-header.vue?vue&type=script&lang=js"

import "./collection-sticky-header.vue?vue&type=style&index=0&id=20e3c706&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__